import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import {
    OidcClient
} from "@axa-fr/oidc-client";
import {
    CONFIGURATION_NAME
} from "@jutro/auth/clients/generic/constants";
import {
    getOidcConfiguration
} from "@jutro/auth/clients/generic/getOidcConfiguration";
import {
    swPolyfill
} from "@jutro/auth/clients/generic/swPolyfill";
swPolyfill();
export var getGenericAuthClient = function(basePath) {
    var listenersId, oidc = OidcClient.getOrCreate((function() {
        return fetch
    }))(getOidcConfiguration(basePath), CONFIGURATION_NAME);
    return {
        getTokens: function() {
            return oidc.tokens
        },
        getUserInfo: function() {
            return oidc.userInfoAsync()
        },
        login: function(callbackPath, extraParams) {
            return oidc.loginAsync(callbackPath, extraParams)
        },
        logout: function(fromPath, extraParams) {
            return oidc.logoutAsync(fromPath, extraParams)
        },
        loginRedirect: function() {
            return _asyncToGenerator(_regeneratorRuntime.mark((function _callee() {
                var _yield$oidc$loginCall, callbackPath;
                return _regeneratorRuntime.wrap((function(_context) {
                    for (;;) switch (_context.prev = _context.next) {
                        case 0:
                            return _context.next = 2, oidc.loginCallbackAsync();
                        case 2:
                            return _yield$oidc$loginCall = _context.sent, callbackPath = _yield$oidc$loginCall.callbackPath, _context.abrupt("return", {
                                callbackPath: callbackPath
                            });
                        case 5:
                        case "end":
                            return _context.stop()
                    }
                }), _callee)
            })))()
        },
        getRoutesConfiguration: function() {
            return {
                redirectUri: oidc.configuration.redirect_uri,
                silentLoginUri: oidc.configuration.silent_login_uri,
                silentRedirectUri: oidc.configuration.silent_redirect_uri
            }
        },
        restoreSession: function() {
            return _asyncToGenerator(_regeneratorRuntime.mark((function _callee2() {
                return _regeneratorRuntime.wrap((function(_context2) {
                    for (;;) switch (_context2.prev = _context2.next) {
                        case 0:
                            return _context2.next = 2, oidc.tryKeepExistingSessionAsync();
                        case 2:
                        case "end":
                            return _context2.stop()
                    }
                }), _callee2)
            })))()
        },
        silentLogin: function(extraParams, scope) {
            return _asyncToGenerator(_regeneratorRuntime.mark((function _callee3() {
                return _regeneratorRuntime.wrap((function(_context3) {
                    for (;;) switch (_context3.prev = _context3.next) {
                        case 0:
                            return _context3.next = 2, oidc.loginAsync(void 0, extraParams, !0, scope);
                        case 2:
                        case "end":
                            return _context3.stop()
                    }
                }), _callee3)
            })))()
        },
        silentLoginRedirect: function() {
            return oidc.silentLoginCallbackAsync()
        },
        renewTokens: extraParams => {
            return oidc.renewTokensAsync(extraParams);
        },
        registerStateListeners: function(_ref) {
            var onTokenChanged = _ref.onTokenChanged,
                onTokenRefreshFailure = _ref.onTokenRefreshFailure,
                onError = _ref.onError;
            listenersId && oidc.removeEventSubscription(listenersId), listenersId = oidc.subscribeEvents((function(name, data) {
                var _context4, _context5;
                _includesInstanceProperty(_context4 = [OidcClient.eventNames.logout_from_another_tab, OidcClient.eventNames.logout_from_same_tab, OidcClient.eventNames.token_acquired, OidcClient.eventNames.token_renewed, OidcClient.eventNames.tryKeepExistingSessionAsync_end]).call(_context4, name) && onTokenChanged(oidc.tokens), name === OidcClient.eventNames.refreshTokensAsync_error && onTokenRefreshFailure(), _includesInstanceProperty(_context5 = [OidcClient.eventNames.loginAsync_error, OidcClient.eventNames.loginCallbackAsync_error, OidcClient.eventNames.silentLoginAsync_error, OidcClient.eventNames.syncTokensAsync_error, OidcClient.eventNames.tryKeepExistingSessionAsync_error]).call(_context5, name) && onError(name, data)
            }))
        },
        removeStateListeners: function() {
            oidc.removeEventSubscription(listenersId)
        },
        cleanup: function() {
            return _asyncToGenerator(_regeneratorRuntime.mark((function _callee4() {
                return _regeneratorRuntime.wrap((function(_context6) {
                    for (;;) switch (_context6.prev = _context6.next) {
                        case 0:
                            oidc.removeEventSubscription(listenersId);
                        case 1:
                        case "end":
                            return _context6.stop()
                    }
                }), _callee4)
            })))()
        }
    }
};
